
import spinnerStyle from "./Spinner1.module.scss";
import { SpinnerProps } from "./types";

const Spinner1: React.FC<SpinnerProps> = ({ color = "orange", fontSize = "100px" }) => (
    <span style={{ color, fontSize }} className={spinnerStyle.loader} />
);

export default Spinner1;




